import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectionNoticeService } from '../../web-auth/connection-notice.service';

@Component({
  selector: 'kx-connection-notice',
  standalone: true,
  imports: [TranslateModule],
  template: `@if (n.visible()) {
    <div role="status" data-test="connection-notice" class="px-4 py-2 text-sm bg-surface-100 dark:bg-surface-800 flex items-center justify-between">
      <span>{{ 'common.connectionRetry' | translate }}</span>
      <button type="button" class="p-button-text" (click)="n.hide()">×</button>
    </div>
  }`,
})
export class ConnectionNoticeComponent {
  protected readonly n = inject(ConnectionNoticeService);
}
